import { Spin, Table } from "antd";
// import { Radio, Spin, Table } from "antd";
import React, { useEffect, useMemo, useState } from "react";
import { vehicleStatusListApiUrl } from "./endpoints";
import { getApis } from "./apis";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "./Constants";
import NoData from "./NoData";

// const dummyVehicleType = [
//   { label: "IMEI", value: "vehImei" },
//   { label: "Chassis No", value: "vehChassisNo" },
//   { label: "Regn No", value: "vehRegNo" },
// ];

const VehiclesListTable = ({ vehicleListModalDetails }) => {
  const authToken = localStorage.getItem("authToken");
  const navigate = useNavigate();
  const [vehicleTableData, setVehicleTableData] = useState({
    List: [],
    totalElements: 0,
    loading: true,
  });
  const [paginationDetails, setPaginationDetails] = useState({
    current: 1,
    pageSize: 10,
  });

  const getVehicleStatusList = async () => {
    await getApis(
      vehicleStatusListApiUrl,
      {
        status: vehicleListModalDetails?.status,
        page: paginationDetails.current - 1,
        size: paginationDetails.pageSize,
      },
      authToken
    )
      .then((response) => {
        setVehicleTableData((prev) => ({
          ...prev,
          List:
            response?.data?.statusMap?.[vehicleListModalDetails?.status]
              ?.vehicles || [],
          totalElements:
            response?.data?.statusMap?.[vehicleListModalDetails?.status]
              ?.totalElements || 0,
          loading: false,
        }));
      })
      .catch((e) => {
        console.log(e.response?.data?.message);
        setVehicleTableData((prev) => ({
          ...prev,
          List: [],
          totalElements: 0,
          loading: false,
        }));
      });
  };

  useMemo(() => {
    if (vehicleTableData.totalElements) {
      getVehicleStatusList();
    }

    // eslint-disable-next-line
  }, [paginationDetails]);

  useEffect(() => {
    if (vehicleListModalDetails?.status) {
      setVehicleTableData((prev) => ({
        ...prev,
        List:
          vehicleListModalDetails?.statusMap?.[vehicleListModalDetails?.status]
            ?.vehicles || [],
        totalElements:
          vehicleListModalDetails?.statusMap?.[vehicleListModalDetails?.status]
            ?.totalElements,
        loading: false,
      }));

      const intervalId = setInterval(() => {
        getVehicleStatusList();
      }, 60 * 1000);

      return () => clearInterval(intervalId);
    } else {
      setVehicleTableData((prev) => ({
        ...prev,
        List: [],
        totalElements: 0,
        loading: true,
      }));
    }

    // eslint-disable-next-line
  }, [vehicleListModalDetails]);

  const handlePageChange = (pagination) => {
    setPaginationDetails({
      current: pagination.current,
      pageSize: pagination.pageSize,
    });
  };

  const onRowClick = (record) => {
    navigate(ROUTES.VEHICLE_ANALYTICS.link, {
      state: { vehImei: record?.vehImei, vehId: record?.vehId },
    });
  };

  const columns = [
    {
      title: "IMEI",
      dataIndex: "vehImei",
      key: "vehImei",
      align: "center",
      className: "grey imei-text bold",
    },
    // {
    //   title: "Chassis No",
    //   dataIndex: "vehChassisNo",
    //   key: "vehChassisNo",
    //   align: "center",
    //   className: "grey imei-text bold",
    // },
    // {
    //   title: "Regn No",
    //   dataIndex: "vehRegNo",
    //   key: "vehRegNo",
    //   align: "center",
    //   className: "grey imei-text bold",
    // },
  ];

  return vehicleTableData?.List?.length > 0 ? (
    <>
      {/* <div className="flex-center">
        <Radio.Group
          // onChange={onChangeVehicleFilter}
          // value={vehicleFilter?.name}
          className="align-center mb1 w75"
          optionType="button"
          // size="large"
          buttonStyle="solid"
        >
          {dummyVehicleType.map((radio, index) => (
            <React.Fragment key={index}>
              <Radio.Button
                value={radio.value}
                className="w100 text-center p0 text-overflow"
              >
                {radio.label}
              </Radio.Button>
            </React.Fragment>
          ))}
        </Radio.Group>
      </div> */}
      <Table
        data-testid="vehicles-list-table"
        columns={columns}
        dataSource={vehicleTableData.List}
        rowKey={(record) => record.vehId}
        rowClassName="cursor-pointer"
        scroll={{ x: "100%" }}
        onChange={handlePageChange}
        className="vehicles-list-table"
        pagination={{
          current: paginationDetails.current,
          pageSize: paginationDetails.pageSize,
          total: vehicleTableData.totalElements,
          showSizeChanger: false,
          showQuickJumper: false,
          hideOnSinglePage: true,
        }}
        onRow={(record) => {
          return {
            onClick: () => onRowClick(record),
          };
        }}
      />
    </>
  ) : vehicleTableData?.loading ? (
    <div className="pd3025 flex-center" data-testid="loading-vehicles-list">
      <Spin className="mt3" />
    </div>
  ) : (
    <div className="pd3025" data-testid="empty-vehicles-list">
      <NoData />
    </div>
  );
};

export default VehiclesListTable;
